import { getEnv } from "config/Config";
import { eaFetch, objToQueryString } from "services/common/ApiUtils";


export async function searchCreditsafeCompanyForThirdParty(accountId, thirdpartyId, dispatch) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "GET",
    `account/${accountId}/thirdparties/${thirdpartyId}/creditsafe/search`,
  );
}


export async function getCreditsafeScoreForThirdParty(accountId, thirdpartyId, dispatch) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "GET",
    `account/${accountId}/thirdparties/${thirdpartyId}/creditsafe/report`,
  );
}


export async function getCreditsafeScoreForThirdPartyForceUpdate(accountId, thirdpartyId, dispatch) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "GET",
    `account/${accountId}/thirdparties/${thirdpartyId}/creditsafe/report/force-update`,
  );
}

export async function stopCreditsafeScoreForThirdParty(accountId, thirdpartyId, dispatch) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "POST",
    `account/${accountId}/thirdparties/${thirdpartyId}/creditsafe/stop`,
  );
}

export async function getFinancialStatementsForThirdParty(accountId, thirdpartyId, dispatch) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "GET",
    `account/${accountId}/thirdparties/${thirdpartyId}/creditsafe/financials`,
  );
}

export async function getCreditsafeThirdpartyDocument(
  accountId,
  thirdpartyId,
  dispatch
) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "GET",
    `account/${accountId}/thirdparties/${thirdpartyId}/creditsafe/document`
  );
}

export async function getCreditsafeScoresCount(accountId, scoresFilters, dispatch, signal) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "GET",
    `account/${accountId}/thirdparties/risks/creditsafe?${objToQueryString(scoresFilters)}`,
    null, null, null, signal
  );
}

export async function getCreditsafeScoreHistory( accountId, thirdpartyId, dispatch, signal) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'GET',
    `account/${accountId}/thirdparties/${thirdpartyId}/creditsafe/history`,
    null,
    null,
    signal
  );
}